import { format } from "$/lib/utils/functions/date.functions";
import Flexbox from "../../common/Flexbox";
import {
  GraphIndicatorItem,
  type GraphIndicatorItemType,
} from "./GraphIndicatorItem";

type DateTypes = GraphIndicatorItemType;

type Props = {
  selectedDate: Date;
  data: DateTypes[];
  indicatorsTitles: {
    title1: string;
    title2: string;
  };
};

export const GraphIndicators = ({
  selectedDate,
  data,
  indicatorsTitles,
}: Props) => {
  return (
    <Flexbox
      fullWidth
      className="min-w-[300px] overflow-y-auto rounded-lg shadow-displayBoxShadow2"
    >
      <Flexbox
        fullWidth
        row
        align="center"
        justify="between"
        className="grid grid-cols-3 border-b-[1px] border-primary-300 bg-primary-200 p-1 text-center text-sm font-medium text-black"
      >
        <span className="text-primary">
          {format(selectedDate, "dd/MM/yyyy")}
        </span>
        <span>{indicatorsTitles.title1}</span>
        <span>{indicatorsTitles.title2}</span>
      </Flexbox>

      {data.map((item, index) => (
        <GraphIndicatorItem key={index} item={item} />
      ))}
    </Flexbox>
  );
};
